import { Component, OnInit } from '@angular/core';
import { SuperAdminJob, SuperAdminService } from '../services.service';


@Component({
  selector: 'app-superadmin-jobs',
  templateUrl: './superadmin-jobs.component.html',
  styleUrls: ['./superadmin-jobs.component.css']
})
export class SuperadminJobsComponent implements OnInit {

  jobs:      SuperAdminJob[] = [];
  filtered:  SuperAdminJob[] = [];
  pagedJobs: SuperAdminJob[] = [];

  loading = true;

  searchQuery     = '';
  selectedCompany = '';
  selectedStatus  = '';

  // Pagination
  currentPage  = 1;
  pageSize     = 15;
  totalPages   = 1;
  pageNumbers: number[] = [];

  Math = Math;

  constructor(private superAdminService: SuperAdminService) {}

  ngOnInit(): void {
    this.loadJobs();
  }

  loadJobs(): void {
    this.loading = true;
    this.superAdminService.getAllJobs().subscribe({
      next: data => {
        this.jobs    = data;
        this.applyFilter();
        this.loading = false;
      },
      error: () => { this.loading = false; }
    });
  }

  // ── Filter ────────────────────────────────────────────────

  applyFilter(): void {
    let result = [...this.jobs];

    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      result = result.filter(j =>
        j.title.toLowerCase().includes(q)         ||
        j.locationName?.toLowerCase().includes(q)  ||
        j.companyName?.toLowerCase().includes(q)
      );
    }

    if (this.selectedCompany) {
      result = result.filter(j => j.companyName === this.selectedCompany);
    }

    if (this.selectedStatus !== '') {
      result = result.filter(j => j.status === Number(this.selectedStatus));
    }

    this.filtered    = result;
    this.currentPage = 1;
    this.buildPagination();
    this.updatePage();
  }

  // ── Pagination ────────────────────────────────────────────

  buildPagination(): void {
    this.totalPages  = Math.max(1, Math.ceil(this.filtered.length / this.pageSize));
    this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1)
      .filter(p => Math.abs(p - this.currentPage) <= 2);
  }

  updatePage(): void {
    const start   = (this.currentPage - 1) * this.pageSize;
    this.pagedJobs = this.filtered.slice(start, start + this.pageSize);
    this.buildPagination();
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePage();
  }

  // ── Computed ──────────────────────────────────────────────

  countByStatus(status: number): number {
    return this.jobs.filter(j => j.status === status).length;
  }

  get companyNames(): string[] {
    return [...new Set(
      this.jobs
        .map(j => j.companyName)
        .filter((n): n is string => !!n)
    )].sort();
  }

  // ── Helpers ───────────────────────────────────────────────

  getStatusLabel(status: number): string {
    const labels: Record<number, string> = {
      0: 'Pending',
      1: 'InProgress',
      2: 'Completed',
      3: 'Failed'
    };
    return labels[status] ?? 'Unknown';
  }
}